// extracted by mini-css-extract-plugin
export default {"downBox":"fileList_downBox__tfFiA","formBox":"fileList_formBox__MTByE"};